'use strict';

exports.__esModule = true;
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _assign5 = require('lodash/assign');

var _assign6 = _interopRequireDefault(_assign5);

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _ValidationError = require('./ValidationError');

var _ValidationError2 = _interopRequireDefault(_ValidationError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Validator = function () {
  function Validator() {
    (0, _classCallCheck3.default)(this, Validator);

    this.rules = {};
    this.addRules.apply(this, arguments);

    this.component = null;
    this.errors = {};
    this.isValid = undefined;
    this.isInvalid = undefined;
  }

  Validator.prototype.attachComponent = function attachComponent(component) {
    this.component = component;
  };

  Validator.prototype.addRules = function addRules() {
    var _this = this;

    for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
      rules[_key] = arguments[_key];
    }

    this.rules = (0, _reduce2.default)(rules, function (acc, rule) {
      // If rule is intance of Validator
      // then add it to this.rules and attach component
      if (rule instanceof Validator) {
        var _assign;

        return (0, _assign6.default)(acc, (_assign = {}, _assign[(0, _size2.default)(acc)] = rule, _assign));
      }
      // If rule is a function
      // then add it to this.rules with next numeric index
      if (typeof rule === 'function') {
        var _assign2;

        return (0, _assign6.default)(acc, (_assign2 = {}, _assign2[(0, _size2.default)(acc)] = rule, _assign2));
      }
      // If rule is plain object
      // then just assign it to this.rules
      if ((typeof rule === 'undefined' ? 'undefined' : (0, _typeof3.default)(rule)) === 'object') {
        return (0, _assign6.default)(acc, rule);
      }
      return acc;
    }, this.rules);

    // Attach component to each rule which are instances of Validator
    (0, _each2.default)(this.rules, function (rule) {
      if (rule instanceof Validator) {
        rule.attachComponent(_this.component);
      }
    });

    return this;
  };

  Validator.prototype.removeRules = function removeRules() {
    for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      rules[_key2] = arguments[_key2];
    }

    this.rules = (0, _pickBy2.default)(this.rules, function (rule, ruleKey) {
      return !(0, _some2.default)(rules, function (ruleToRemove) {
        return ruleToRemove === rule || ruleToRemove.toString() === ruleKey;
      });
    });
    return this;
  };

  Validator.prototype.getRule = function getRule(ruleKey) {
    return this.rules[ruleKey];
  };

  Validator.prototype.getAllErrors = function getAllErrors() {
    return this.errors;
  };

  Validator.prototype.getError = function getError(ruleKey) {
    return ruleKey ? this.errors[ruleKey] : (0, _first2.default)((0, _values2.default)(this.errors));
  };

  Validator.prototype.getErrorMessage = function getErrorMessage(ruleKey) {
    var error = this.getError(ruleKey);
    return error ? error.message : null;
  };

  Validator.prototype.wasValidated = function wasValidated() {
    return this.isValid !== undefined;
  };

  Validator.prototype.findErrors = function findErrors() {
    return (0, _reduce2.default)(this.rules, function (acc, rule, ruleKey) {
      // Rule is function
      if (typeof rule === 'function') {
        try {
          rule();
        } catch (e) {
          if (e instanceof _ValidationError2.default) {
            var _assign3;

            (0, _assign6.default)(acc, (_assign3 = {}, _assign3[ruleKey] = e, _assign3));
          } else {
            throw e;
          }
        }
        // Rule is instance of Validator
      } else if (rule instanceof Validator) {
        rule.validate({ shouldComponentUpdate: false });
        if (rule.isInvalid) {
          var _assign4;

          (0, _assign6.default)(acc, (_assign4 = {}, _assign4[ruleKey] = rule.getError(), _assign4));
        }
      }
      return acc;
    }, {});
  };

  Validator.prototype.validate = function validate() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$shouldComponentU = _ref.shouldComponentUpdate,
        shouldComponentUpdate = _ref$shouldComponentU === undefined ? true : _ref$shouldComponentU;

    // Find errors
    this.errors = this.findErrors();

    // Update properties
    this.isValid = !(0, _size2.default)(this.errors);
    this.isInvalid = !this.isValid;

    // Update component
    if (shouldComponentUpdate) {
      this.updateComponent();
    }

    return this;
  };

  Validator.prototype.reset = function reset() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$shouldComponent = _ref2.shouldComponentUpdate,
        shouldComponentUpdate = _ref2$shouldComponent === undefined ? true : _ref2$shouldComponent,
        _ref2$shouldResetRule = _ref2.shouldResetRuleValidators,
        shouldResetRuleValidators = _ref2$shouldResetRule === undefined ? true : _ref2$shouldResetRule;

    // Reset fields
    this.errors = {};
    this.isValid = undefined;
    this.isInvalid = undefined;

    // Reset rule validators
    if (shouldResetRuleValidators) {
      (0, _each2.default)(this.rules, function (rule) {
        if (rule instanceof Validator) {
          rule.reset({ shouldComponentUpdate: false });
        }
      });
    }

    // Update component
    if (shouldComponentUpdate) {
      this.updateComponent();
    }

    return this;
  };

  Validator.prototype.updateComponent = function updateComponent() {
    if (this.component) {
      this.component.setState({
        validatorToken: (0, _uniqueId2.default)('validator')
      });
    }
  };

  return Validator;
}();

exports.default = Validator;
//# sourceMappingURL=Validator.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-vld/lib/Validator.js
// module id = 506
// module chunks = 0